/**
 * @fileoverview Endless Runner Layout
 * @description Navigation layout for Endless Runner screens
 */

import { Stack } from "expo-router";

export default function EndlessRunnerLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[sessionId]" />
    </Stack>
  );
}

